import { render } from "./NewsDetal.vue?vue&type=template&id=5b70c62d&scoped=true"
import script from "./NewsDetal.vue?vue&type=script&lang=js"
export * from "./NewsDetal.vue?vue&type=script&lang=js"

import "./NewsDetal.vue?vue&type=style&index=0&id=5b70c62d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b70c62d"]])

export default __exports__